export default [
    {
        path: '/migrant',
        name: '场景对话练习',
        component: r => require.ensure([], () => r(require('@/views/migrant/index')), 'user')
    },
    {
        path: '/migrant/home',
        name: '场景对话练习',
        component: r => require.ensure([], () => r(require('@/views/migrant/home')), 'user')
    },
    {
        path: '/migrant/class/:id',
        name: '场景对话练习',
        component: r => require.ensure([], () => r(require('@/views/migrant/class')), 'user')
    },
    {
        path: '/migrant/list/:id',
        name: '场景对话练习',
        component: r => require.ensure([], () => r(require('@/views/migrant/list')), 'user')
    },
    {
        path: '/migrant/details/:id',
        name: '场景对话练习',
        component: r => require.ensure([], () => r(require('@/views/migrant/details')), 'user')
    }

]


// WEBPACK FOOTER //
// ./src/router/routers/migrant.js